import { PatientService } from "../PatientService";
export const PortalAuthService = {
    async requestOtp(destination) {
        await PatientService.sendPhoneVerificationOtp(destination);
    },
    async verifyOtp(destination) {
        await PatientService.verifyPhoneVerificationOtp(destination);
    },
};
